// JavaScript Document

const FORMS = document.querySelectorAll(".weblinx-search-form");

FORMS.forEach((form) => {
    const INPUT     = form.querySelector("[name=s]");
    const PROVIDERS = form.querySelectorAll("[name=provider]");

    if (PROVIDERS.length > 0) {
        PROVIDERS.forEach((provider) => {
            provider.addEventListener("change", () => {
                let placeholder = "";
                let target      = "";

                const OPTION = provider.querySelector(`[value=${provider.value}]`);

                if (OPTION) {
                    if (OPTION.dataset.placeholder) {
                        placeholder = OPTION.dataset.placeholder;
                    }

                    if (OPTION.dataset.target) {
                        target = OPTION.dataset.target;
                    }
                } else {
                    if (provider.dataset.placeholder) {
                        placeholder = provider.dataset.placeholder;
                    }

                    if (provider.dataset.target) {
                        target = provider.dataset.target;
                    }
                }

                if (placeholder) {
                    INPUT.setAttribute("placeholder", placeholder);
                }

                if (target) {
                    form.setAttribute("target", target);
                }
            });
        });
    }
});
